export default __webpack_public_path__ + "static/media/p1-3.01e50d66.png";